import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import { includes, filter } from 'lodash';
import SearchStoreListModal from '../../../../views/widget/common/modal/SearchStoreListModal';
import withModal from '../../../../lib/hoc/withModal';
import { widgetActions } from '../../../../store/modules/widget';
import { appActions } from '../../../../store/modules/app';
import { comparePrePropsAndNextProps } from '../../../../lib/common';
import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';

class SearchStoreModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedStoreList: [],
      selectedStoreIdList: props.data.selectedId ? [props.data.selectedId] : [],
    };
  }

  componentDidMount = () => {
    this.initiate(this.props.data.selectedId);
  };

  componentDidUpdate(prevProps) {
    if (comparePrePropsAndNextProps([[prevProps.data.selectedItem, this.props.data.selectedItem]])) {
      this.setState({
        selectedStoreList: [this.props.data.selectedItem],
      });
    }
  }

  initiate = (storeId) => {
    this.getList({
      selectedWidgetItemIdList: [storeId],
      pagination: LIST_PAGINATION_MODEL,
    });
  };

  /**
   * 브랜드 선택하기
   */
  onSubmit = () => {
    const { selectedStoreList, selectedStoreIdList } = this.state;
    const { setData, data } = this.props;
    const { targetPath } = data;

    const selectedStoreId = selectedStoreIdList[0];

    /**
     *  브랜드가 선택되었는지 체크
     */
    if (!selectedStoreId) {
      message.error('브랜드를 선택해주세요.');
      return;
    }

    setData({
      path: [...targetPath, 'linkId'],
      value: selectedStoreId,
    });

    /**
     *  선택된 기획전네임 가져오기
     */
    const brandName = selectedStoreList[0].storeName;

    setData({
      path: [...targetPath, 'linkName'],
      value: brandName,
    });

    this.closeModal();
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'searchStoreListModal', value: false });
  };

  /**
   * 브랜드 리스트 가져오기
   */
  getList = (option) => {
    const { getStoreList, data } = this.props;
    const { listPath, listData } = data;
    const { filterOption, pagination } = listData;

    getStoreList({
      filterOption,
      pagination,
      ...option,
      listPath,
    });
  };

  /**
   * 브랜드 선택 callback
   */
  onCheckStore = (list) => {
    const { selectedStoreIdList } = this.state;
    const { data } = this.props;
    let targetIdList = list;

    if (list.length > 1) {
      targetIdList = filter(list, (id) => id !== selectedStoreIdList[0]);
    }

    const targetList = filter(data.listData.list, (item) => includes(targetIdList, item.id));

    this.setState({
      selectedStoreList: targetList,
      selectedStoreIdList: targetIdList,
    });
  };

  render() {
    return (
      <SearchStoreListModal
        {...this.state}
        {...this.props}
        onSubmit={this.onSubmit}
        closeModal={this.closeModal}
        getStoreList={this.getList}
        onCheckStore={this.onCheckStore}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.widget.searchStoreListModal.isOpen,
    data: state.widget.searchStoreListModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: widgetActions.toggleModal,
  setData: widgetActions.setData,
  getStoreList: widgetActions.getStoreList,
  openImgViewModal: appActions.openImgViewModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(SearchStoreModalContainer));
